module.exports = __webpack_public_path__ + "img/verticalLift3.7af19ce2.png";